import React from 'react';
import { TwoColumnsBlock } from "../../types/optimizely/blocks";
import { ContentArea } from '../ContentArea/ContentArea';

const TwoColumnsComponent: React.FC<TwoColumnsBlock> = ({
  leftColumnScrollableContent,
  rightColumnScrollableContent,
  leftColumn,
  rightColumn,
}) => {
  return (
    <div className="flex flex-col md:flex-row">
      <div className="w-full md:w-1/2 flex-1" style={leftColumnScrollableContent.value ? { position: 'sticky', top: 0, height: '100%' } : {}}>
        {leftColumn && <ContentArea contentArea={leftColumn} />}
      </div>
      <div className="w-full md:w-1/2 flex-1" style={rightColumnScrollableContent.value ? { position: 'sticky', top: 0, height: '100%' } : {}}>
        {rightColumn && <ContentArea contentArea={rightColumn} />}  
      </div>
    </div>
  );
};

export default TwoColumnsComponent;
